"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/tx-activity-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Ftx-activity-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxActivityServiceClient = exports.GetMostRecentRenderedActivityByPaymentResponse = exports.GetMostRecentRenderedActivityByPaymentRequest = exports.GetRenderedActivityResponse = exports.GetRenderedActivityRequest = exports.GetActivityByPaymentResponse = exports.GetActivityByPaymentRequest = exports.GetAccountActivityResponse = exports.GetAccountActivityRequestAccountIds = exports.GetAccountActivityRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const paging_1 = require("../paging/paging");
const activity_context_1 = require("./activity-context");
const activity_feed_1 = require("./activity-feed");
const activity_item_1 = require("./activity-item");
const activity_query_1 = require("./activity-query");
const activity_tag_1 = require("./activity-tag");
const activity_view_1 = require("./activity-view");
const protobufPackage = 'com.step.txactivity.proto';
function createBaseGetAccountActivityRequest() {
    return {
        primaryAccountId: undefined,
        subAccountId: undefined,
        primaryAccountIds: undefined,
        paging: undefined,
        tags: [],
        activityTypes: [],
        merchantEnrichedId: '',
    };
}
exports.GetAccountActivityRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        if (isSet(object.subAccountId)) {
            message.subAccountId = globalThis.String(object.subAccountId);
        }
        if (isSet(object.primaryAccountIds)) {
            message.primaryAccountIds = exports.GetAccountActivityRequestAccountIds.fromJSON(object.primaryAccountIds);
        }
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        if (globalThis.Array.isArray(object?.tags)) {
            message.tags = object.tags.map((e) => (0, activity_tag_1.tagFromJSON)(e));
        }
        if (globalThis.Array.isArray(object?.activityTypes)) {
            message.activityTypes = object.activityTypes.map((e) => (0, activity_context_1.activityContextTypeFromJSON)(e));
        }
        if (isSet(object.merchantEnrichedId)) {
            message.merchantEnrichedId = globalThis.String(object.merchantEnrichedId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== undefined) {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.subAccountId !== undefined) {
            obj.subAccountId = message.subAccountId;
        }
        if (message.primaryAccountIds !== undefined) {
            obj.primaryAccountIds = exports.GetAccountActivityRequestAccountIds.toJSON(message.primaryAccountIds);
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        if (message.tags?.length) {
            obj.tags = message.tags.map((e) => (0, activity_tag_1.tagToJSON)(e));
        }
        if (message.activityTypes?.length) {
            obj.activityTypes = message.activityTypes.map((e) => (0, activity_context_1.activityContextTypeToJSON)(e));
        }
        if (message.merchantEnrichedId !== undefined && message.merchantEnrichedId !== '') {
            obj.merchantEnrichedId = message.merchantEnrichedId;
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountActivityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountActivityRequest();
        message.primaryAccountId = object.primaryAccountId ?? undefined;
        message.subAccountId = object.subAccountId ?? undefined;
        message.primaryAccountIds =
            (object.primaryAccountIds !== undefined && object.primaryAccountIds !== null)
                ? exports.GetAccountActivityRequestAccountIds.fromPartial(object.primaryAccountIds)
                : undefined;
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        message.tags = object.tags?.map((e) => e) || [];
        message.activityTypes = object.activityTypes?.map((e) => e) || [];
        message.merchantEnrichedId = object.merchantEnrichedId ?? '';
        return message;
    },
};
function createBaseGetAccountActivityRequestAccountIds() {
    return { accountIds: [] };
}
exports.GetAccountActivityRequestAccountIds = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.accountIds)) {
            message.accountIds = object.accountIds.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountIds?.length) {
            obj.accountIds = message.accountIds;
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountActivityRequestAccountIds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountActivityRequestAccountIds();
        message.accountIds = object.accountIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetAccountActivityResponse() {
    return { activity: [], paging: undefined };
}
exports.GetAccountActivityResponse = {
    fromJSON(object) {
        const message = {
            activity: globalThis.Array.isArray(object?.activity)
                ? object.activity.map((e) => activity_item_1.ActivityItem.fromJSON(e))
                : [],
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.activity?.length) {
            obj.activity = message.activity.map((e) => activity_item_1.ActivityItem.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountActivityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountActivityResponse();
        message.activity = object.activity?.map((e) => activity_item_1.ActivityItem.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetActivityByPaymentRequest() {
    return { primaryAccountId: '', paymentId: '' };
}
exports.GetActivityByPaymentRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.GetActivityByPaymentRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetActivityByPaymentRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseGetActivityByPaymentResponse() {
    return { activity: activity_item_1.ActivityItem.fromPartial({}) };
}
exports.GetActivityByPaymentResponse = {
    fromJSON(object) {
        const message = {
            activity: isSet(object.activity)
                ? activity_item_1.ActivityItem.fromJSON(object.activity)
                : activity_item_1.ActivityItem.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.activity !== undefined) {
            obj.activity = activity_item_1.ActivityItem.toJSON(message.activity);
        }
        return obj;
    },
    create(base) {
        return exports.GetActivityByPaymentResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetActivityByPaymentResponse();
        message.activity = (object.activity !== undefined && object.activity !== null)
            ? activity_item_1.ActivityItem.fromPartial(object.activity)
            : activity_item_1.ActivityItem.fromPartial({});
        return message;
    },
};
function createBaseGetRenderedActivityRequest() {
    return {
        account: undefined,
        filter: undefined,
        feed: activity_feed_1.ActivityFeed.INVALID_ACTIVITY_FEED,
        accountId: '',
        merchantId: '',
        paging: undefined,
    };
}
exports.GetRenderedActivityRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.account)) {
            message.account = activity_query_1.AccountQuery.fromJSON(object.account);
        }
        if (isSet(object.filter)) {
            message.filter = activity_query_1.ActivityFilter.fromJSON(object.filter);
        }
        if (isSet(object.feed)) {
            message.feed = (0, activity_feed_1.activityFeedFromJSON)(object.feed);
        }
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        if (isSet(object.merchantId)) {
            message.merchantId = globalThis.String(object.merchantId);
        }
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = activity_query_1.AccountQuery.toJSON(message.account);
        }
        if (message.filter !== undefined) {
            obj.filter = activity_query_1.ActivityFilter.toJSON(message.filter);
        }
        if (message.feed !== undefined && message.feed !== activity_feed_1.ActivityFeed.INVALID_ACTIVITY_FEED) {
            obj.feed = (0, activity_feed_1.activityFeedToJSON)(message.feed);
        }
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.merchantId !== undefined && message.merchantId !== '') {
            obj.merchantId = message.merchantId;
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetRenderedActivityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRenderedActivityRequest();
        message.account = (object.account !== undefined && object.account !== null)
            ? activity_query_1.AccountQuery.fromPartial(object.account)
            : undefined;
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? activity_query_1.ActivityFilter.fromPartial(object.filter)
            : undefined;
        message.feed = object.feed ?? activity_feed_1.ActivityFeed.INVALID_ACTIVITY_FEED;
        message.accountId = object.accountId ?? '';
        message.merchantId = object.merchantId ?? '';
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetRenderedActivityResponse() {
    return { activities: [], paging: undefined };
}
exports.GetRenderedActivityResponse = {
    fromJSON(object) {
        const message = {
            activities: globalThis.Array.isArray(object?.activities)
                ? object.activities.map((e) => activity_view_1.ActivityView.fromJSON(e))
                : [],
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.activities?.length) {
            obj.activities = message.activities.map((e) => activity_view_1.ActivityView.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetRenderedActivityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRenderedActivityResponse();
        message.activities = object.activities?.map((e) => activity_view_1.ActivityView.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetMostRecentRenderedActivityByPaymentRequest() {
    return { primaryAccountId: '', paymentId: '' };
}
exports.GetMostRecentRenderedActivityByPaymentRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.GetMostRecentRenderedActivityByPaymentRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetMostRecentRenderedActivityByPaymentRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseGetMostRecentRenderedActivityByPaymentResponse() {
    return { activity: undefined };
}
exports.GetMostRecentRenderedActivityByPaymentResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.activity)) {
            message.activity = activity_view_1.ActivityView.fromJSON(object.activity);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.activity !== undefined) {
            obj.activity = activity_view_1.ActivityView.toJSON(message.activity);
        }
        return obj;
    },
    create(base) {
        return exports.GetMostRecentRenderedActivityByPaymentResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetMostRecentRenderedActivityByPaymentResponse();
        message.activity = (object.activity !== undefined && object.activity !== null)
            ? activity_view_1.ActivityView.fromPartial(object.activity)
            : undefined;
        return message;
    },
};
/**
 * Public Transaction Activity Service API.
 *
 * Combines low-level transactions from the ledger into more user-friendly
 * activity items visible in the app and web admin.
 */
class TxActivityServiceClient {
    rpc;
    name = 'com.step.txactivity.proto.TxActivityService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/txactivity';
    methods = [{
            name: 'GetAccountActivity',
            requestType: exports.GetAccountActivityRequest,
            responseType: exports.GetAccountActivityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetActivityByPayment',
            requestType: exports.GetActivityByPaymentRequest,
            responseType: exports.GetActivityByPaymentResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetRenderedActivity',
            requestType: exports.GetRenderedActivityRequest,
            responseType: exports.GetRenderedActivityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetMostRecentRenderedActivityByPayment',
            requestType: exports.GetMostRecentRenderedActivityByPaymentRequest,
            responseType: exports.GetMostRecentRenderedActivityByPaymentResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Returns activity for the given account
     */
    getAccountActivity(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the most recent activity for the given account and payment
     */
    getActivityByPayment(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns server-rendered activity for the given feed.
     */
    getRenderedActivity(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the most recent server-rendered activity for the given account and
     * payment.
     *
     * Used to fetch activities referenced by notifications.
     */
    getMostRecentRenderedActivityByPayment(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.TxActivityServiceClient = TxActivityServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx-activity-service.js.map